import { Button, Col, Form, Input, Row } from 'antd';
import { useHistory } from 'react-router-dom';

import AddressUnitsSelector from '../../components/common/AddressUnitSelector';
import {
  BRANCH_NAME_MAX_LENGTH,
  PHONE_NUMBER_LENGTH,
  branchNameRules,
  phoneNumberRules,
} from '../../utils/formRules';
import BranchLocationPicker from './BranchLocationPicker';
import './profilepage.less';

const { TextArea } = Input;

/** Салбарын жагсаалт руу буцах зам (Тохиргооны "Салбарууд" таб) */
const BRANCH_TAB_PATH = { pathname: '/settings', search: '?tab=branch' };

/** Хаягийн сонголтууд мөрөндөө ижил зайтай байхын тулд */
const addressStyleProps = { rowGutter: [16, 0] };

/**
 * Формын талбарууд картын бүтэн өргөнөөр сунахгүй — зүүн талд багцлагдаж,
 * баруун талд зай үлдэнэ.
 */
const FORM_MAX_WIDTH = 900;

const BranchForm = ({ addressArray, setAddressArray, form, onOk, submitting = false }) => {
  const history = useHistory();

  return (
    <Form layout="vertical" form={form}>
      <div style={{ maxWidth: FORM_MAX_WIDTH }}>
        <Row gutter={[16, 0]}>
          <Col xs={24} sm={12} xl={8}>
            <Form.Item name="name" label="Салбарын нэр" rules={branchNameRules()}>
              <Input placeholder="Энд бич" maxLength={BRANCH_NAME_MAX_LENGTH} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} xl={8}>
            <Form.Item
              name="phoneNumber"
              label="Салбарын утас"
              rules={phoneNumberRules('Салбарын утас дутуу байна.')}
            >
              <Input placeholder="Энд бич" maxLength={PHONE_NUMBER_LENGTH} />
            </Form.Item>
          </Col>
        </Row>

        {/*
          Салбарын хаяг нь ЗААВАЛ санаатай сонголт байх ёстой. Автомат анхдагч
          сонголттой үед хэрэглэгч гурван талбарт огт хүрээгүй атал тэдгээр нь
          чимээгүй бөглөгдөж, заавал шалгуур давж, эхний аймаг/сум/хорооны
          хаягтай салбар бүртгэгддэг байв.
        */}
        <AddressUnitsSelector
          selectedUnits={addressArray}
          onChange={setAddressArray}
          form={form}
          autoSelectFirst={false}
          styleProps={addressStyleProps}
        />

        <Form.Item
          name="addressDetail"
          label="Дэлгэрэнгүй хаяг"
          rules={[{ required: true, message: 'Дэлгэрэнгүй хаяг дутуу байна.' }]}
          style={{ marginBottom: 0 }}
        >
          <TextArea rows={4} placeholder="Энд бич" />
        </Form.Item>

        {/*
          Засах формтой ижил газрын зургийн панель. Өмнө нь нэмэх формд огт
          байгаагүй тул шинэ салбар бүр ижил хатуу бичсэн координаттай
          хадгалагддаг байв.
        */}
        <BranchLocationPicker form={form} />
      </div>

      <div className="edit_page_buttons">
        <Button onClick={() => history.push(BRANCH_TAB_PATH)}>Буцах</Button>
        <Button type="primary" loading={submitting} onClick={onOk}>
          Шинээр нэмэх
        </Button>
      </div>
    </Form>
  );
};

export default BranchForm;
